export default __webpack_public_path__ + "static/media/view all icon.3b833996.png";